const STORAGE_KEY = 'rmf:user-photo';

function getUploadedPhotoUrl() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data.imageUrl || null;
  } catch {
    return null;
  }
}

/**
 * Convert a base64 data URL to a blob URL so the image is decoded once
 * and reused across all card overlays without repeated base64 parsing.
 */
async function toBlobUrl(dataUrl) {
  try {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch {
    return dataUrl;
  }
}

/**
 * Compute object-fit:cover rendered position of an image inside a container.
 * Returns offset (may be negative = overflows) and rendered dimensions.
 */
function coverLayout(containerW, containerH, imgAspect) {
  const containerAspect = containerW / containerH;
  let renderedW, renderedH, offsetX, offsetY;
  if (imgAspect > containerAspect) {
    renderedH = containerH;
    renderedW = containerH * imgAspect;
    offsetX = (containerW - renderedW) / 2;
    offsetY = 0;
  } else {
    renderedW = containerW;
    renderedH = containerW / imgAspect;
    offsetX = 0;
    offsetY = (containerH - renderedH) / 2;
  }
  return { renderedW, renderedH, offsetX, offsetY };
}

function swapPhoto(photoUrl) {
  // Path A: cards with a css-mode mock (.mock-image__artwork already in DOM)
  document.querySelectorAll('[data-rmf-card] .mock-image__artwork:not([data-photo-swapped])').forEach(img => {
    img.src = photoUrl;
    img.srcset = '';
    img.sizes = '';
    img.dataset.photoSwapped = '1';
  });

  // Path B: cards with a pre-baked pcv2-img + hero_mock corners
  document.querySelectorAll('[data-rmf-card][data-mock-corners]:not([data-photo-swapped])').forEach(card => {
    const pcvArt = card.querySelector('.pcv2-art');
    if (!pcvArt) return;

    const corners = JSON.parse(card.dataset.mockCorners || '[]');
    if (corners.length !== 4) return;

    // Validate corner values are normalised 0-1 floats
    const valid = corners.every(c => {
      const x = parseFloat(c.x), y = parseFloat(c.y);
      return !isNaN(x) && !isNaN(y) && x >= 0 && x <= 1 && y >= 0 && y <= 1;
    });
    if (!valid) return;

    const imgAspect = parseFloat(card.dataset.imgAspect) || 1.0;
    const rect = pcvArt.getBoundingClientRect();
    if (!rect.width) return;

    const { renderedW, renderedH, offsetX, offsetY } = coverLayout(rect.width, rect.height, imgAspect);

    const overlay = document.createElement('mock-image-css3d');
    overlay.className = 'mock-image-container';
    overlay.dataset.corners = card.dataset.mockCorners;
    overlay.dataset.frameAspect = String(imgAspect);
    overlay.dataset.artworkAspect = '1.0';
    overlay.dataset.frameSrc = '';
    overlay.dataset.frameLightingOpacity = '0';
    overlay.style.cssText = [
      'position:absolute',
      `left:${offsetX}px`,
      `top:${offsetY}px`,
      `width:${renderedW}px`,
      `height:${renderedH}px`,
      'pointer-events:none',
    ].join(';');

    const img = document.createElement('img');
    img.className = 'mock-image__artwork';
    img.src = photoUrl;
    img.alt = '';
    overlay.appendChild(img);

    pcvArt.appendChild(overlay);
    card.dataset.photoSwapped = '1';

    // If mock-image-css3d couldn't apply a perspective transform (bad corners),
    // the img will have no transform style — remove the failed overlay.
    setTimeout(() => {
      if (!img.style.transform) overlay.remove();
    }, 300);
  });
}

async function init() {
  return; // disabled — mock rect positioning needs fixing first
  const dataUrl = getUploadedPhotoUrl();
  if (!dataUrl) return;

  const photoUrl = await toBlobUrl(dataUrl);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => swapPhoto(photoUrl), { once: true });
  } else {
    swapPhoto(photoUrl);
  }

  // Re-swap after filter/pagination re-renders the grid.
  const grid = document.querySelector('results-list, collection-page') || document.body;
  new MutationObserver(() => swapPhoto(photoUrl)).observe(grid, { childList: true, subtree: true });
}

init();
